// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --body-bg-color: #f1f5ff;
  --primary-color: #1b5bff;
  --seconadry-color: #a370ce;
  --seconadry-ic-bg: #eeebff;
  --pirmary-ic-bg: #dae4fe;
  --dark-heading-text: #1e1e1e;
  --light-heading-text: #4d4d4d;
  --text-color: #6b6b6b;
  --white-color: #fff;
  --gradient-color: linear-gradient(to bottom, #a370ce, #103799);
}

/* body {
  background: var(--body-bg-color);
} */

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--seconadry-color);
  box-shadow: rgba(100, 100, 111, 0.3) 0px 7px 29px 0px;
  border-bottom: 1px solid var(--seconadry-ic-bg);
  color: var(--white-color);
  padding: 20px 100px;
}

.navbar-left {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-grow: 1;
}

.logos {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.logoImg{
  width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    display: flex
;
    align-items: center;
    justify-content: center;
}
.logoImg img {
      width: 100%;
    height: 100%;
    object-fit: cover;
}
.logos h1 {
  font-size: 24px;
    font-weight: 600;
    color: var(--white-color);
    margin-bottom: 0px;
}
.navbar-menu {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-left: auto;
  /* flex-grow: 1; */
  font-size: 18px;
  color: var(--white-color);
}
.navbar-menu.open {
  display: flex;
}

.navbar-menu ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}
.navLink {
  text-decoration: none;
  color: white;
  font-weight: 500;
  padding: 8px 12px;
  transition: color 0.3s ease, border-bottom 0.3s ease;
}

.navLink:hover {
  color: white;
  border-bottom: 2px solid white;
}

.navbar-menu li {
  margin: 0;
  color: var(--white-color);
  text-decoration: none;
  padding: 0.5rem 1rem;
}

.navbar-buttons {
  display: flex;
  gap: 0.5rem;
  margin-left: auto;
}

.btns {
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.signup_btn {
  background: none;
  border: 1px solid var(--seconadry-ic-bg);
}

.demo {
  background: var(--white-color);
  color: var(--seconadry-color);
  border: 1px solid var(--seconadry-ic-bg);
}

.navbar-toggler {
  display: none;
  font-size: 1.5rem;
  background: none;
  border: none;
  color: var(--white-color);
  cursor: pointer;
}

/* Mobile styles */
@media (max-width: 1120px) {
  .navbar {
    padding: 20px 30px;
    z-index: 10;
  }
  .navbar-left {
    flex-direction: row;
    justify-content: space-between;
  }
  .navbar-menu {
    display: none;
    position: absolute;
    top: 90px;
    right: 0;
    background-color: var(--seconadry-color);
    width: 100%;
    text-align: center;
    padding: 1rem;
    /* z-index: -1; */
    color: var(--dark-heading-text);
    width: 200px;
    flex-direction: column;
    align-items: flex-end;
  }
  .navbar-menu.open {
    display: flex;
  }
  .navbar-menu ul {
    flex-direction: column;
    padding: 0;
  }

  .navbar-buttons {
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
  }
  .navbar-toggler {
    display: block;
    margin-left: auto;
  }
}

@media (max-width: 368px) {
  .navbar {
    padding: 10px 16px;
  }
  .logos h1 {
    font-size: 18px;
  }
  .navbar-menu {
    top: 68px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/Auth/Header/Header.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,8DAA8D;AAChE;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,qDAAqD;EACrD,+CAA+C;EAC/C,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;IACT,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;MACM,WAAW;IACb,YAAY;IACZ,iBAAiB;AACrB;AACA;EACE,eAAe;IACb,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,wCAAwC;IACxC,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  --body-bg-color: #f1f5ff;\n  --primary-color: #1b5bff;\n  --seconadry-color: #a370ce;\n  --seconadry-ic-bg: #eeebff;\n  --pirmary-ic-bg: #dae4fe;\n  --dark-heading-text: #1e1e1e;\n  --light-heading-text: #4d4d4d;\n  --text-color: #6b6b6b;\n  --white-color: #fff;\n  --gradient-color: linear-gradient(to bottom, #a370ce, #103799);\n}\n\n/* body {\n  background: var(--body-bg-color);\n} */\n\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: var(--seconadry-color);\n  box-shadow: rgba(100, 100, 111, 0.3) 0px 7px 29px 0px;\n  border-bottom: 1px solid var(--seconadry-ic-bg);\n  color: var(--white-color);\n  padding: 20px 100px;\n}\n\n.navbar-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-grow: 1;\n}\n\n.logos {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n.logoImg{\n  width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    overflow: hidden;\n    display: flex\n;\n    align-items: center;\n    justify-content: center;\n}\n.logoImg img {\n      width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n.logos h1 {\n  font-size: 24px;\n    font-weight: 600;\n    color: var(--white-color);\n    margin-bottom: 0px;\n}\n.navbar-menu {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-left: auto;\n  /* flex-grow: 1; */\n  font-size: 18px;\n  color: var(--white-color);\n}\n.navbar-menu.open {\n  display: flex;\n}\n\n.navbar-menu ul {\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.navLink {\n  text-decoration: none;\n  color: white;\n  font-weight: 500;\n  padding: 8px 12px;\n  transition: color 0.3s ease, border-bottom 0.3s ease;\n}\n\n.navLink:hover {\n  color: white;\n  border-bottom: 2px solid white;\n}\n\n.navbar-menu li {\n  margin: 0;\n  color: var(--white-color);\n  text-decoration: none;\n  padding: 0.5rem 1rem;\n}\n\n.navbar-buttons {\n  display: flex;\n  gap: 0.5rem;\n  margin-left: auto;\n}\n\n.btns {\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.signup_btn {\n  background: none;\n  border: 1px solid var(--seconadry-ic-bg);\n}\n\n.demo {\n  background: var(--white-color);\n  color: var(--seconadry-color);\n  border: 1px solid var(--seconadry-ic-bg);\n}\n\n.navbar-toggler {\n  display: none;\n  font-size: 1.5rem;\n  background: none;\n  border: none;\n  color: var(--white-color);\n  cursor: pointer;\n}\n\n/* Mobile styles */\n@media (max-width: 1120px) {\n  .navbar {\n    padding: 20px 30px;\n    z-index: 10;\n  }\n  .navbar-left {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n  .navbar-menu {\n    display: none;\n    position: absolute;\n    top: 90px;\n    right: 0;\n    background-color: var(--seconadry-color);\n    width: 100%;\n    text-align: center;\n    padding: 1rem;\n    /* z-index: -1; */\n    color: var(--dark-heading-text);\n    width: 200px;\n    flex-direction: column;\n    align-items: flex-end;\n  }\n  .navbar-menu.open {\n    display: flex;\n  }\n  .navbar-menu ul {\n    flex-direction: column;\n    padding: 0;\n  }\n\n  .navbar-buttons {\n    flex-direction: column;\n    gap: 1rem;\n    margin-top: 1rem;\n  }\n  .navbar-toggler {\n    display: block;\n    margin-left: auto;\n  }\n}\n\n@media (max-width: 368px) {\n  .navbar {\n    padding: 10px 16px;\n  }\n  .logos h1 {\n    font-size: 18px;\n  }\n  .navbar-menu {\n    top: 68px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
